const PressArea = () => {
    return <div>Press Area</div>;
};

export default PressArea;
